{
  "addAddress": "Dodaj adres",
  "addContactData": "Dodaj dane kontaktowe",
  "additionalId": "Numer artykułu",
  "additionalStockInfos": "Dodatkowe informacje o akcjach",
  "additionalTax": "plus{0} VAT",
  "addProducts": "Dodaj produkty",
  "addProductToCollection": "Dodaj produkt do kolekcji",
  "addProductToComparison": "Dodaj produkt do porównania produktu",
  "addProductToQuote": "Dodaj produkt do zapytania",
  "address": {
    "addition": "Dodatkowy adres",
    "city": "Miasto",
    "clientNumber": "Numer klienta",
    "companyName": "Nazwa i forma prawna",
    "country": "Kraj",
    "defaultBillingAddress": "Domyślny adres do faktury",
    "defaultDeliveryAddress": "Domyślny adres wysyłki",
    "details": "Szczegóły",
    "email": "Email",
    "phone": "Telefon",
    "postBox": "Skrzynka pocztowa",
    "primaryAddress": "Adres siedziby firmy",
    "street": "Ulica",
    "url": "URL",
    "website": "Strona internetowa",
    "zipCode": "Kod pocztowy",
    "zipCodeLong": "Kod pocztowy"
  },
  "addresses": "Adresy",
  "addToCart": "Dodaj do koszyka",
  "archiveAll": "Archiwizuj wszystko",
  "availability": "Dostępność",
  "b2bCommerPowered": "Powered by ITscope B2B Commerce",
  "backToPlatform": "Powrót do ITscope",
  "billingAddress": "Adres do faktury",
  "cancel": "Anuluj",
  "cart": {
    "optimizationFailed": "Optymalizacja koszyka nie powiodła się",
    "optimizationUnavailable": "Optymalizacja koszyka nie mogła zostać przeprowadzona, ponieważ w koszyku znajduje się wiecej niz 250 produktów",
    "removeAll": "Opróżnij koszyk",
    "removeAllError": "Koszyk nie mógł zostać opróżniony",
    "removeAllSuccess": "Koszyk został pomyślnie opróżniony"
  },
  "cartOutdated": {
    "description": "Zamówienie nie mogło zostać wysłane, ponieważ koszyk nie jest już aktualny. Proszę przeładować koszyk i złożyć zamówienie ponownie.",
    "title": "Koszyk nie jest już aktualny"
  },
  "cartPositionComment": "Komentarz do produktu",
  "categories": "Kategorie",
  "changed": "Zmieniono",
  "changePassword": "Zmiana hasła",
  "charger": {
    "charger": "Ładowarka w zestawie",
    "chargerIncludedTooltip": "Ładowarka jest dołączona do tego produktu.",
    "chargerNotIncludedHint": "Ładowarki z następującymi zgodnościami ładowania mogą być używane z tym produktem.",
    "chargerNotIncludedTooltip": "Ładowarka nie jest dołączona do tego produktu.",
    "noCharger": "Brak ładowarki w zestawie"
  },
  "checkEmail": "Sprawdź pocztę e-mail",
  "checkoutExpiredDialog": {
    "buttonCaption": "Powrót do kasy",
    "description": "Twoje zamówienie czeka",
    "title": "Nadal tam jesteś?"
  },
  "chooseAddress": "Wybierz adres",
  "clientNumber": "Numer klienta",
  "closeErrorOrders": "Zamknij kolumnę z błędnymi zamówieniami",
  "closeFilter": "Zamknij filtr",
  "closeMessage": "Zamknij wiadomość",
  "closeQuoteActivity": "Zamknięte działania",
  "collapseAccessoryCategory": "Zwiń kategorię akcesoriów „{0}”",
  "collapseDescription": "Zwiń opis „{0}”",
  "collection": {
    "addAttachment": "Dodaj załącznik",
    "addCollection": "Nowy zbiór",
    "addedToCartFailure": "Kolekcja nie mogła zostać dodana do koszyka",
    "addedToCartPartialSuccess": "Niektórych produktów nie można dodać do koszyka",
    "addedToCartSuccess": "Dodano zbiór do koszyka",
    "addProductToExistingCollection": "Dodaj produkt do istniejącego zbioru:",
    "addProductToNewCollection": "lub utworz nowy zbiór :",
    "addToCart": "Dodaj do koszyka",
    "assignee": "Odpowiedzialny pracownik",
    "collections": " Zbiór",
    "collectProduct": "Dodaj produkt",
    "data": "Dane",
    "deleteAction": "Usuń zbiór",
    "deleteDialog": "Czy na pewno chcesz usunąć ten zbiór?",
    "deletedMessage": "Zbiór został usunięty",
    "duplicate": "Powiel",
    "editTitle": "Zmień tytuł kolekcji",
    "emailSent": "Zbiór został pomyślnie wysłany drogą elektroniczną.",
    "emptyCollection": "Brak produktów w tym zbiorze",
    "lastModified": "Ostatnio zmodyfikowany",
    "noCollectionAvailable": "Brak zbioru",
    "productAlreadyInCollection": "Produkt juz w kolekcji",
    "sendEmail": "Udostępnij przez e-mail",
    "shareCollection": "Prześlij zbiór \"{0}\" mailem",
    "subject": "Tytuł",
    "success": {
      "itemRemoved": "Produkt został pomyślnie usunięty"
    }
  },
  "common": {
    "archive": "Dodaj do archiwum",
    "archived": " aktualnie w archiwum",
    "comment": "Kometarz",
    "commentPlaceholder": "Dodaj komentarz tutaj...",
    "comments": "Komentarze",
    "dearchive": "Usuń z archiwum",
    "error": {
      "changeQuantity": "Ilość nie mogła zostać zmieniona",
      "removeItem": "Pozycja nie może zostać usunięta",
      "updateAssignee": "Nie można było zmienić odpowiedzialnego pracownika",
      "updateComment": "Komentarz nie mógł zostać zaktualizowany",
      "updateName": "Tytuł zbioru nie mógł zostać zaktualizowany"
    },
    "sellerComment": "Komentarz dla sprzedającego"
  },
  "company": {
    "deleteEmployee": "Usunąć pracownika",
    "employee": "Pracownik",
    "employeeDeleted": "Pracownik został usunięty",
    "employees": "Pracownicy"
  },
  "companyData": "Dane firmy",
  "companyRegistration": "Dla podanego adresu e-mail nie istnieje jeszcze firma. Wypełnij poniższy formularz, aby poprosić o dostęp.",
  "condition": {
    "B_STOCK": "B-stock",
    "BUILD_TO_ORDER": "Konfiguracja na zamówienie",
    "BULK": "bez opakowania",
    "DEMONSTRATION_MODEL": "Model demonstracyjny",
    "FACTORY_REFURBISHED": "Fabrycznie odnowiony",
    "NEW": "Nowy",
    "NEWPULL": "Część wymieniona z nowego urządzenia",
    "NOT_FOR_RESALE": "Nie do ponownej sprzedaży",
    "REFURBISHED": "Odnowiony",
    "RMA_WARE": "RMA/Zwrot",
    "USED": "Używany",
    "USEDPULL": "Część wymieniona z używanego urządzenia"
  },
  "conditionTooltip": {
    "conditionLabel": "Stan",
    "monthsWarranty": "miesięcy gwarancji"
  },
  "contactData": {
    "contactData": "dane kontaktowe",
    "email": "E-mail",
    "firstName": "Imię",
    "lastName": "Nazwisko"
  },
  "contactTitles": {
    "diverse": "nieokreślony",
    "female": "Pani.",
    "male": "Pan.",
    "unspecified": "brak"
  },
  "continue": "Kontynuuj",
  "copy": "Kopia",
  "coreData": "Dane podstawowe",
  "costs": "Koszty",
  "create": "Utwórz",
  "created": "Utworzony",
  "createdDate": "Data utworzenia",
  "cto": {
    "appleCtoFinder": "Wyszukiwarka CTO Apple",
    "configure": "skonfiguruj {0}",
    "customiseConfiguration": "Dopasowanie konfiguracji",
    "foundProduct": "Znaleziony produkt",
    "noProductFound": "Nie udało się znaleźć produktu dla tej konfiguracji",
    "selectBaseModel": "Wybierz model podstawowy",
    "selectedConfiguration": "Wybrana konfiguracja",
    "selectProductClass": "Wybierz klasę produktów Apple"
  },
  "customerOrderId": "Numer zamówienia klienta",
  "datasheet": "Dane techniczne",
  "datasheetError": "Nie można załadować arkusza danych",
  "datasheetManufacturer": "Karta techniczne producenta",
  "datasheetNotFound": "Brak arkusza danych dla tego produktu",
  "datasheetPdf": "Dane techniczne (PDF)",
  "decline": "Odmowa",
  "declineReason": "Przyczyna odmowy",
  "delete": "Usuń",
  "deleteAddress": "Usunąć adres",
  "deleteAddressDialog": "Czy na pewno chcesz usunąć ten adres?",
  "deleteContactData": "Usuń dane kontaktowe",
  "deliveryTracking": {
    "deliveryTracking": "Informacje o wysyłce",
    "trackPackage": "Monitorowanie przesyłki"
  },
  "departments": {
    "Accounting": "Księgowość",
    "Extern": "Zewnętrzny",
    "IT": "IT",
    "Management": "Zarząd",
    "Marketing": "Marketing",
    "Other": "Inne",
    "Purchasing": "Zakupy",
    "RegistrationPending": "Rejestracja w toku",
    "Sales": "Sprzedaż",
    "ServiceSupport": "Serwis/Support"
  },
  "discount": "- {0} zniżka",
  "documentError": "Nie można wczytać dokumentu",
  "downloadAllOrderDocumentsAsPdf": "Pobierz wszystkie dokumenty zamówienia w formacie PDF",
  "downloadOrderDocumentAsPdf": "Pobierz dokument zamówienia „{0}” w formacie PDF",
  "ean": "EAN",
  "editAddress": "Edytuj adres",
  "editCollectionAssignee": "Zmień odpowiedzialnego pracownika",
  "editContactData": "Edycja danych kontaktowych",
  "ellipsis": "...",
  "emailAddress": "Adres e-mail",
  "emailForRegistration": "Wprowadź adres e -mail, z którym chcesz się zarejestrować.",
  "emailRequestPriceHint": "Do operatora portalu zostanie wysłany następujący mail (jest to tylko podgląd tekstu):",
  "emptyCart": "W koszyku nie ma żadnego produktu",
  "epeat": "EPEAT-gecertificeerd",
  "epeatTooltip": {
    "description1": "Międzynarodowe oznakowanie ekologiczne dla produktów IT.",
    "description2": "Ocenia między innymi efektywność energetyczną, możliwość recyklingu i wybór materiałów.",
    "description3": "Poziomy: Brązowy, Srebrny, Złoty - im wyższy, tym bardziej przyjazny dla środowiska.",
    "title": "Etykieta EPEAT"
  },
  "eprel": {
    "energyEfficiency": "Etykieta energetyczna",
    "energyEfficiencyAndProductDatasheet": "Informacje o etykiecie energetycznej",
    "energyEfficiencyInformationSheet": "Karta informacyjna"
  },
  "error": {
    "addressCreated": "Nie można utworzyć adresu",
    "addressDeleted": "Adres nie może zostać usunięty",
    "addressesNotFound": "Nie udało się załadować adresów",
    "addressPropertyInvalid": "Pole adresu {propertyName} jest nieprawidłowe.",
    "addressSaved": "Nie można zapisać adresu",
    "alreadyInvited": "Kolega {0} jest już zaproszony",
    "alreadyRegistered": "Pracownik {0} jest już zarejestrowany",
    "cartNotFound": "Nie można załadować koszyka",
    "categoriesNotFound": "Nie udało się załadować kategorii",
    "changePassword": "Coś poszło nie tak podczas próby zmiany hasła",
    "changeQuantity": "Ilość w koszyku nie mogła zostać zmieniona",
    "collectionNotFound": "Zbiór nie może być załadowany",
    "documentsNotFound": "Nie udało się załadować dokumentów",
    "emailAlreadyRegistered": "Email jest już zarejestrowany.",
    "emptyField": "Wpis {0} musi mieć prawidłową wartość",
    "essentialShopActivationRequested": "Podczas wysyłania zapytania wystąpił błąd",
    "fileTooLarge": "Plik jest za duży",
    "genericError": "Coś poszło nie tak",
    "identifiersNotFound": "Numery seryjne nie mogły zostać załadowane",
    "invalidCharacters": "Dopuszczalne są wyłącznie litery, cyfry oraz znaki _ / . # +, a także nawiasy okrągłe i kwadratowe (co najmniej 3 znaki)",
    "invalidEmail": "Nieprawidłowy adres e-mail",
    "invalidEmails": "Następujące adresy e-mail są niedozwoline: {0}",
    "invalidName": "Nieprawidłowa nazwa",
    "invalidNegativeNumber": "Dopuszczalne są tylko liczby dodatnie",
    "invalidNumber": "Nieprawidłowy numer",
    "invalidUrl": "Nieprawidłowy adres url",
    "invalidWhitespace": "Niedozwolone spacje na początku, na końcu lub wielokrotne kolejne spacje",
    "invitation": "Coś poszło nie tak podczas próby wysłania zaproszenia",
    "keywordTooShort": "Wprowadź wyszukiwane hasło składające się z co najmniej 2 znaków",
    "mailBlacklisted": "Domena {0} nie została zaakceptowana. Skontaktuj się z administratorem portalu...",
    "noAdmin": "Do zapraszania współpracowników potrzebne są uprawnienia administratora",
    "noConsent": "Zgoda musi być potwierdzona",
    "oldPassword": "Stare hasło jest błędne",
    "ordersNotFound": "Nie udało się załadować zamówień",
    "pageNotFound": "Nie znaleziono strony",
    "passwordNotAllowedChar": "Hasło zawiera jeden lub więcej niedozwolonych znaków.",
    "passwordRepeat": "Podane hasła nie są zgodne",
    "passwordRequirements": "Twoje hasło nie spełnia aktualnych wymagań dotyczących haseł.",
    "positiveDigit": "Wartość musi być dodatnia",
    "productAdded": "Produkt nie może być dodany do koszyka",
    "productAlreadyInComparison": "Produkt jest już w porównaniu",
    "productComparisonMaxNumber": "Można porównać maksymalnie 3 produkty",
    "productDeleted": "Produkt nie może być usunięty z koszyka",
    "productNotAvailableBySupplier": "Ten dostawca nie oferuje tego produktu.",
    "productNotFound": "Produkt nie może być załadowany",
    "productRequest": "Coś poszło nie tak podczas próby wysłania zapytania",
    "productTypeIncorrectForComparison": "Porównywane mogą być tylko produkty z tej samej kategorii.",
    "quoteForbidden": "Oferta nie jest jeszcze aktywna",
    "quoteNotFound": "Oferta nie została załadowana",
    "quotesNotFound": "Nie udało się załadować ofert",
    "refresh": "Inni użytkownicy wprowadzili zmiany. Odśwież stronę.",
    "registration": "Coś poszło nie tak podczas próby wysłania rejestracji",
    "registrationTokenError": "Link do rejestracji nowego użytkownika wydaje się być błędny. Proszę poprosić o nowy.",
    "requiredField": "Wymagane pole",
    "resetPassword": "Coś poszło nie tak podczas próby zresetowania hasła",
    "resetTokenError": "Link do zresetowania hasła nie jest już ważny. Proszę poprosić o nowy.",
    "serverError": "Błąd serwera",
    "shortPassword": "Musi zawierać co najmniej 8 znaków",
    "startPage": "Strona startowa nie może być załadowana",
    "timeout": "Zapytanie przekroczyło maksymalny czas oczekiwiania",
    "tooManyRequests": "Zbyt wiele zapytań. Spróbuj ponownie później.",
    "unknownError": "Podczas zapytania wystąpił nieznany błąd ({0}).",
    "unknownLoginError": "Podczas logowania wystąpił nieznany błąd.",
    "unsupportedMediaType": "Typ pliku nie jest obsługiwany",
    "updateComment": "Komentarz do produktu nie mógł zostać zaktualizowany",
    "userDeactivated": "Podany użytkownik jest nieaktywny, logowanie jest obecnie nie możliwe.",
    "validDigit": "Wartość musi być poprawną liczbą całkowitą",
    "wrongCredentials": "Twój adres e-mail lub hasło są nieprawidłowe."
  },
  "errorId": "Identyfikator błędu",
  "errorPageHeadline": "Coś poszło nie tak.",
  "errorPageOops": "Ooops",
  "errorPageQuoteNotAvailableSorry": "Spróbuj ponownie później.",
  "errorPageStart": "Przejdź do strony startowej",
  "essentialShopDeactivated": {
    "descriptionEnd": "Aby uzyskać dostęp, skontaktuj się ze swoim partnerem",
    "descriptionPoint1": "przeglądania historii swoich ofert",
    "descriptionPoint2": "składać zapytania ofertowe bezpośrednio do swojego partnera",
    "descriptionPoint3": "uzyskać dostęp do asortymentu 50 000 produktów IT z filtrem i wyszukiwarką",
    "descriptionPoint4": "składać zamówienia w prosty i bezpośredni sposób",
    "descriptionStart": "W sklepie Essential masz możliwość:",
    "descriptionTitle": "Sklep Essential Twojego partnera jest obecnie wyłączony",
    "pageTitle": "Sklep Essential dezaktywowany",
    "requestActivation": "Poproś o aktywację",
    "requestActivationHint": "Podaj swój adres e-mail, aby Twój partner mógł się z Tobą skontaktować."
  },
  "excludingVatHint": "Wszystkie ceny bez{0} VAT",
  "excludingVatShort": "bez{0} VAT",
  "expandAccessoryCategory": "Rozwiń kategorię akcesoriów „{0}”",
  "expandDescription": "Rozwiń opis „{0}”",
  "featureAd": {
    "comparison": {
      "description": "Produkty do porównania można dodawać z poziomu strony produktu",
      "shortDescription": "Możesz teraz porównywać produkty.",
      "title": "Porównanie produktów"
    },
    "descriptionEnd": "Zostaniemy powiadomieni i przygotujemy Państwu bezpośrednio w portalu ofertę do zamówienia.",
    "descriptionStart": " W ten sposób można zapytać o zebrane produkty:",
    "NEW": "NOWE",
    "requestFunction": "Wysyłanie zapytań ofertowych",
    "step1": "Kliknij \"Utwórz zapytanie\"",
    "step2": "Dodaj produkty",
    "step3": "Wyślij zapytanie",
    "tryItOut": "Spróbuj!"
  },
  "filter": {
    "filter": "Filtr",
    "filters": "Filtry",
    "noFiltersSelected": "Nie wybrano żadnych filtrów",
    "productFilters": "Cechy",
    "productType": "Rodzaj produktu",
    "resetFilter": "Wyzeruj filtr"
  },
  "finishRegistration": "Zakończyć rejestrację",
  "forgotPassword": "Nie pamiętasz hasła?",
  "grading": {
    "A": "Jak nowy",
    "B": "Bardzo dobry",
    "C": "Dobry",
    "D": "Akceptowalny"
  },
  "hideCategories": "Ukryj kategorie",
  "hideCategory": "Złóż kategorię",
  "hidePassword": "Ukryj hasło",
  "impersonateMode": "Widok klienta - Jesteś zalogowany jako administrator sklepu B2B w {0}",
  "impersonateModeEssentialShop": "Widok klienta – Zalogowany jako właściciel sklepu",
  "includingVat": "w tym{0} VAT",
  "includingVatHint": "Wszystkie ceny zawierają{0} VAT",
  "includingVatShort": "w tym{0} VAT",
  "invitationHint": "Tutaj możesz zaprosić innych pracowników do swojego portalu. Wpisz adresy e-mail, na które chcesz wysłać zaproszenie i oddziel je średnikiem lub spacją.",
  "inviteColleagues": "Zaproś kolegów",
  "languages": {
    "de": "Niemiecki",
    "en": "Angielski",
    "es": "Hiszpański",
    "fr": "Francuski",
    "it": "Włoski",
    "nl": "Holenderski",
    "pl": "Polski"
  },
  "legalInfo": "Informacje prawne",
  "less": "mniej",
  "localization": "Lokalizacja",
  "login": "Login",
  "login_sso": "Zaloguj się za pomocą funkcji Single Sign-On (SSO)",
  "loginQuotesPortal": "Zaloguj się do portalu ofert",
  "manufacturerId": "Identyfikator producenta",
  "max": "Max.",
  "maxLength": "Osiągnięto maksymalną długość znaku {0}",
  "mobex360Info": "Jeśli kredyt mobex360 jest niewystarczający, zamówienie zostanie automatycznie zafakturowane!",
  "mobexPaymentMethod": {
    "CREDIT": "Z kredytem mobex360",
    "INVOICE": "Na fakturę"
  },
  "more": "więcej",
  "moreInfoEpeatTooltip": "Więcej informacji na temat etykiety EPEAT",
  "moreUppercase": "Więcej",
  "myCompany": "Moja firma",
  "myProfile": "Mój profil",
  "name": "Nazwa",
  "newPassword": "Nowe hasło",
  "newPasswordRepeat": "Potwierdź nowe hasło",
  "no": "Nie",
  "noAppleProductsAvailable": "Brak dostępnych produktów Apple",
  "noCategoriesFound": "Brak kategorii",
  "noCollectionsFound": "Brak ziorów",
  "noDataAvailable": "Brak dostępnych danych",
  "noEntries": "Brak wpisów",
  "noImageAvailable": "Brak dostępnego obrazu",
  "noItemsInQuote": "Niniejsza oferta nie zawiera żadnych pozycji",
  "noOrderDocumentsFound": "Brak dokumentów",
  "noOrdersFound": "Brak zamówień",
  "noProductsFound": "Nie znaleziono żadnych produktów",
  "noSupplier": "Nieprzypisane",
  "nullPriceLabel": "-.--",
  "oldPassword": "Aktualne hasło",
  "onlyWholePositiveNumbers": "Dozwolone są tylko liczby całkowite dodatnie",
  "open": "Otwarty",
  "openCart": "Otwórz koszyk",
  "openCategory": "Złóż kategorię",
  "openFilter": "Otwórz filtr",
  "openMenu": "Otwarte menu",
  "openProductComparison": "Otwórz porównanie produktu",
  "openProductPage": "Otwórz stronę produktu",
  "openTopiCheckout": "Otwórz topi-Checkout",
  "optimizationStrategyType": {
    "MANUAL": "Ręcznie",
    "MINPRICE": "Najlepsza cena",
    "MINSUPPLIERS": "minimalna ilość dostawców "
  },
  "order": {
    "addedToCartFailure": "Nie można dodać zamówienia do koszyka",
    "addedToCartPartialSuccess": "Niektórych produktów nie można dodać do koszyka",
    "addedToCartSuccess": "zamówienie dodano do koszyka",
    "customerOrderIdMissing": "Podaj identyfikator klienta docelowego.",
    "declineOrder": "Odrzucenie zamówienia ",
    "deleteDialog": "Czy na pewno chcesz usunąć to zamówienie?",
    "deleteLastItemDialog": "Uwaga: Podczas usuwania ostatniej pozycji zamówienia, zostanie również usunięte całe zamówienie. Czy chcesz kontynuować?",
    "deleteOrder": "Usuń zamówienie",
    "deleteOrderItem": "Usuń pozycję zamówienia",
    "details": "Zamówienie",
    "documents": "Dokumenty",
    "editAddressHint": "Zmiany w adresie dotyczą tylko tego zamówienia.",
    "exclTotalTax": "bez{0} VAT {1}",
    "goToOrder": "Kontynuuj zamówienie",
    "inclTotalTax": "z{0} VAT {1}",
    "inEuTotalTax": "plus{0} VAT {1}",
    "moreInfosLabel": "Dalsze informacje",
    "netDiscount": "dodatkowy rabat",
    "noApprover": "Dla tego zamówienia brakuje uprawinionej osoby zatwierdzającej. Prosimy o kontakt z operatorem portalu.",
    "noOrderRightHint": "Nie masz uprawnień do wykonania zamówienia.",
    "order": "Zamówienie",
    "orderAlreadyBeingProcessed": "Zamówienie jest już przetwarzane. Proszę poczekać kilka minut.",
    "orderDate": "Data zamówienia",
    "orderLimitApprovalHint": "Następujące osoby zostaną powiadomione pocztą elektroniczną o Twoim wniosku w celu zatwierdzenie zamówienia. Gdy zamówienia zostanie potwierdzone lub odrzucone, zostaniesz o tym poinformowany drogą mailową.",
    "orderLimitHint": " Zamówienie o wartości {0} przekroczyło Twój aktualny limit zleceń wynoszący {1}. Poproś o zatwierdzenie zlecenia.",
    "orderNotFound": "Zamówienie nie zostało załadowane",
    "orderNumber": "Numer zamówienia",
    "orderNumberDuplicate": "Numer zamówienia {0} został już użyty w innym zamówieniu. Spróbuj użyć innego numeru zamówienia.",
    "orderNumberGeneratedAfterOrder": "Jest generowany po złożeniu zamówienia",
    "orderNumberMissing": "Należy podać numer zamówienia.",
    "orderNumbers": " Numer zamówień ",
    "orderRequested": "Zapytanie wysłane",
    "orders": "Zamówienia",
    "orderSent": "Twoje zamówienie zostało złożone i jest teraz przetwarzane.",
    "orderTimeoutError": "Nie otrzymano odpowiedzi na zamówienie. Proszę odświeżyć stronę.",
    "partialShipmentAllowed": "Wysyłka częściowa dozwolona.",
    "paymentMethodMissing": "Podaj sposób rozliczenia.",
    "quantitySurcharge": "Dopłata do minimalnego zamówienia",
    "requestOrder": "Zapytania",
    "selectAddressHint": "Można używać tylko adresów utworzonych przez Ciebie.",
    "sendOrder": "Wyślij zamówienie",
    "shippingAddress": "Adres wysyłki",
    "shippingCosts": " Koszty wysyłki ",
    "shippingCostsGross": "Koszty wysyłki brutto",
    "shippingCostsNet": "Koszty wysyłki netto",
    "subTotal": "Suma częściowa",
    "toOrder": "Złóż zamówienie",
    "toOrderFrom": "Zamów u {0}",
    "totalCostsGross": "Całkowita kwota brutto",
    "totalCostsNet": "Całkowita kwota netto"
  },
  "orderApproval": {
    "approvableOrders": "Zamówienia do zatwierdzenia",
    "approvedInformation": "Zamówienie zostało zatwierdzone przez {0} w dniu {1}.",
    "declinedInformation": "Zamówienie zostało odrzucone przez {0} w dniu {1}.",
    "orderDeclined": "Zamówienie zostało odrzucone",
    "pendingInformation": "W dniu {0} zażądano dla tego zamówienia zatwierdzenia od {1} od następujących osób:",
    "pendingInformationApprover": "Prośba o zatwierdzenie tego zamówienia została di Ciebie wysłana w dniu {0}.",
    "pendingInformationRequester": "W dniu {0} przesłałeś prośbe o zatwierdzenie zamówienia następującej osobie:"
  },
  "orderBy": "Złóż zamówienie u {0}",
  "ordered": "Zamówione",
  "orderLimits": {
    "activateOrderLimits": "Aktywuj limity zamówień",
    "default": " Domyślny",
    "defaultApprovers": "Domyślny zatwierdzający",
    "defaultApproversEmpty": "Nie wybrano domyślnych zatwierdzających",
    "defaultApproversUsed": "Wybrano domyślnych zatwierdzających",
    "defaultLimit": "Limit ogólny",
    "defaultLimitDescription": "Ten limit zamówień jest wartością domyślną dla wszystkich pracowników i jest zastępowany indywidualnymi limitami zamówień dla pracowników.",
    "description": "Aktywując limity, pracownicy mogą składać zamówienia tylko do określonej wartości. Zamówienia przekraczające tę wartość, wymagają zatwierdzenia przez pracownika z uprawnieniami.",
    "editOrderLimitUser": "Zmiana limitu zamówienia użytkownika „{0}”",
    "editStandardApprovers": "Edytuj domyślne osoby zatwierdzające",
    "individual": "Indywidualnie",
    "noEmployeeFound": "Nie znaleziono żadnego pracownika",
    "noEmployeesFound": "Brak pracowników",
    "orderApproval": "Zatwierdzenie zamówienia",
    "orderApprover": "Osoba zatwierdzająca zamówienie",
    "orderLimit": "Limit zamówień",
    "orderRight": "Uprawinienie do zamówienia",
    "unlimited": "Nieograniczony"
  },
  "orderOutdated": {
    "description": "Zamówienie nie mogło zostać wysłane, ponieważ jest nieaktualne. Zaktualizuj zamówienie i wykonaj je ponownie.",
    "title": "Zamówienie nie jest już aktualne"
  },
  "orderStatus": {
    "ADVISED": "Wysłane",
    "ARRIVED": " Otrzymane zamówienie ",
    "ARRIVED_WARNING": "Otrzymane z ostrzeżeniem",
    "BLOCKED": "Zablokowane",
    "BLOCKED_BYLIMIT": "Zablokowane",
    "CANCELED": "Anulowane",
    "ERROR": "Błąd",
    "IN_TOPI_CHECKOUT": "W kasie topi",
    "INVOICED": "Zafakturowane",
    "ORDERED_ELSEWHERE": "Zrealizowane inna drogą",
    "PARTIALLY_ADVISED": "Częściowo wysłane",
    "PARTIALLY_INVOICED": "Częściowo zafakturowane",
    "PARTIALLY_PROCESSING": "Częściowo potwierdzone",
    "PAYMENT_AWAITING": "Oczekiwanie na płatność",
    "PAYMENT_SUCCESSFUL": "Płatność zakończona sukcesem",
    "PENDING_TOPI_APPROVAL": "Oczekiwanie na zezwolenie",
    "PORTAL_APPROVAL_DENIED": "Odrzucone",
    "PREPARING": "W oczekiwaniu",
    "PROCESSING": "Zamówienie potwierdzone",
    "REJECTED": "Odrzucone",
    "SENDING_ERROR": "Błąd transmisji",
    "SENT": "Przesłane",
    "TOPI_DECLINED": "Odrzucone przez topi",
    "TOPI_EXPIRED": "Oferta topi wygasła",
    "TRANSMITTING": "W trakcie przesyłania"
  },
  "partsList": "Wykaz elementów",
  "password": "Hasło",
  "passwordRepeat": "Powtórzenie hasła",
  "paymentMethod": "Sposób płatności",
  "PDF": "PDF",
  "per": "każdy",
  "personalData": "Dane osobowe",
  "pleaseSelect": "Proszę wybrać...",
  "portal": "Portal",
  "portalPaused": "Portal chwilowo niedostępny",
  "portalPausedDescription": "Ten portal jest chwilowo niedostępny. Logowanie jest nie możliwe. W razie jakichkolwiek pytań prosimy o kontakt z właścicielem portalu.",
  "positions": "Brak pozycji | {n} pozycji | {n} pozycji",
  "price": {
    "graduatedPrices": "Ceny stopniowane",
    "manufacturerSuggestedRetailPrice": "cena sugerowana",
    "packaging": "Jednostka opakowania",
    "packaging_contentUnit": "Jednostka zawartości:",
    "packaging_contentUnit_label": "Jednostka produktu w jednostce zamówienia (np. \"sztuka\" w jednostce zamówienia \"opakowanie\").",
    "packaging_intervalQuantity": "Progi cenowy:",
    "packaging_intervalQuantity_label": "Ilość wskazująca w jakiej podziałce można zamówić produkt (w jednostkach zamówieniowych).",
    "packaging_minQuantity": "Minimalna ilość zamówienia:",
    "packaging_minQuantity_label": "Najniższa jednostka zamówienia.",
    "packaging_numberContentUnitPerOrderUnit": " Zawartość opakowania:",
    "packaging_numberContentUnitPerOrderUnit_label": "Liczba podjednostek zawartych w jednostce zamówienia.",
    "packaging_orderUnit": "Jednostka zamówienia:",
    "packaging_orderUnit_label": "Jednostka, w której można zamówić produkt; można zamówić tylko wielokrotność jednostki artykułu.",
    "packaging_priceQuantity": "Cena za ilość:",
    "packaging_priceQuantity_label": "Wielokrotność jednostki zamówienia, która wskazuje ilość, do której odnoszą się ceny.",
    "packaging_supplierPackingQuantity": "ilość w opakowaniu dostawcy:",
    "packaging_supplierPackingQuantity_label": "Ilość opakowań dostawcy (w jednostkach zamówieniowych).",
    "price": "Cena",
    "priceBillingPeriod": "za {0}",
    "priceBillingPeriodShort": "p. {0}",
    "priceOnRequest": "O/R",
    "pricePurchase": "cena zakupu u dostawcy",
    "priceSubscriptionPeriod": "{0} okres umowy",
    "priceVatStar": "*",
    "startingAt": "od {0}"
  },
  "priceRange": {
    "applyPriceRange": "Zastosuj przedział cenowy",
    "fromPriceRange": "Od {0} {1}",
    "fromToPriceRange": "{0} {2} - {1} {2}",
    "invalidPriceRange": "Nieprawidłowy zakres cen",
    "priceRange": "Zakres cen",
    "priceRangeFrom": "Zakres cen",
    "priceRangeTo": "Zakres cenowy",
    "toPriceRange": "Do {0} {1}"
  },
  "print": "Drukuj",
  "privacy": "Prywatność",
  "privacyConsent": "Wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie z polityką prywatności.",
  "product": "Produkt",
  "productAccessories": "Akcesoria",
  "productComparison": {
    "highlightDifferences": "Pokaż różnice",
    "noData": "Nie znaleziono porównywalnych danych dla wybranych produktów",
    "noMobileVersion": "Porównanie produktów nie jest dostępne w widoku mobilnym",
    "noProducts": "Brak produktów w porównaniu",
    "pageTitle": "Porównaj produkty",
    "removeProduct": "Usuń produkt z porównania"
  },
  "productDescription": "Opis",
  "productId": "ID produktu",
  "productIdentifiers": "Identyfikatory produktów",
  "productNoLongerAvailable": "Produkt nie jest już dostępny",
  "products": "Produkty",
  "productSort": {
    "AVAILABILITY": "Dostępność",
    "CALC_PRICE_ASC": "Po cenie rosnąco",
    "CALC_PRICE_DESC": "Po cenie malejąco",
    "NAME_ASC": "Po nazwie produktu A do Z",
    "NAME_DESC": "Po nazwie produktu Z-A",
    "POPULARITY": "Popularność",
    "RELEVANCE": "Odpowiedniość",
    "STOCK": "Poziom zapasów"
  },
  "productStockInfo": {
    "nextDelivery": "Następny termin dostawy według dystrybutora oczekiwany w dniu {0}.",
    "nextDeliveryB2B": "Przewidywany termin dostawy do dystrybutora: {0}.",
    "noNextDelivery": "Dokładny termin dostawy nieznany.",
    "onStock": "{0} Dostępny",
    "onSupply": "{0} Wkrótce dostępny",
    "unavailableMessage": "Produkt jest niedostępny."
  },
  "punchout": {
    "backToProcurement": "Przejmij do swojego systemu",
    "backToProcurementCaption": "Bez zamowienia z powrotem do wlasnego systemu | Przejęcie pozycji do wlasnego systemu | {n} pozycji przejąć do wlasnego systemu",
    "table": {
      "position": "Pozycja",
      "price": "Cena",
      "quantity": "Ilość",
      "sum": "Suma",
      "title": "Nazwa"
    }
  },
  "quantityFrom": "Ilość od",
  "quoteOutdated": {
    "description": "Zamówienie nie mogło zostać wysłane, ponieważ oferta nie jest już aktualna. Załaduj ofertę ponownie i złóż zamówienie.",
    "title": "Oferta nie jest już aktualna"
  },
  "quotePreview": "Jesteś w podglądzie oferty",
  "quoteRegistration": {
    "description": "Rejestrując się w swoim osobistym sklepie Essential Shop, otrzymujesz...",
    "products": "Dostęp do <b>50 000 produktów IT</b>",
    "quoteDocument": "wyświetl wszystkie odpowiednie <b>dokumenty ofert</b>",
    "quoteHistory": "<b>historia ofert</b> ze wszystkimi wcześniej otrzymanymi ofertami",
    "quoteRequest": "opcja przesyłania <b>zapytań</b>"
  },
  "quoteRequest": {
    "cannotEditRequest": "Nie ma już możliwości zmiany, zapytanie zostało już wysłane.",
    "emptyRequest": "Nie dodano jeszcze żadnych produktów",
    "lineItemAdded": "Pozycja została dodana pomyślnie",
    "notInAssortment": "Obecnie nie znajduje się w asortymencie",
    "requestAgain": "Zapytaj ponownie",
    "requestNotFound": "Nie można znaleźć zapytania ofertowego",
    "sendRequest": "Wyślij zapytanie",
    "sentQuoteRequest": "Zapytanie ofertowe zostało wysłane",
    "textLineItemAdd": "Dodaj dowolny element tekstowy",
    "textLineItemChangeError": "Nie można zmienić tytułu pozycji tekstowej"
  },
  "quotes": {
    "acceptQuote": "Zaakceptuj ofertę",
    "addProductToExistingQuote": "Dodaj produkt do istniejącego zapytania:",
    "addProductToNewQuote": "lub utwórz nowe zapytanie:",
    "author": "Autor",
    "createRequest": "Utwórz zapytanie",
    "declineInformation": "Oferta została odrzucona przez {0} w dniu {1}.",
    "declineQuote": "Ordzuć oferte",
    "declineQuoteDialog": "Czy na pewno chcesz odrzucić oferte?",
    "deleteDescription": "Czy na pewno chcesz, aby ta oferta została usunięta?",
    "deleteTitle": "Usuń oferte",
    "deselectOptionalItem": "Odznacz pozycję opcjonalną",
    "duplicateUserWarning": "Nie możesz zaakceptować tej oferty, ponieważ Twój adres e-mail został już powiązany z inną firmą. Prosimy o kontakt z twórcą oferty.",
    "editTitle": "Zmień tytuł żądania",
    "new": "Nowa",
    "noLongerValid": "Ta oferta wygasła w dniu \"{0}\" i nie jest już ważna.",
    "noOptionalPosition": "Brak pozycji opcjonalnej",
    "noQuoteEmptySpace": "Nie ma jeszcze żadnej oferty",
    "noQuoteRequestsFound": "Brak dostępnych żądań",
    "noQuotesFound": "Brak dostępnych ofert",
    "quote": "Oferta",
    "quoteRequested": "Oferta została pomyślnie utworzona",
    "quotes": "Oferty",
    "request": "Zapytania",
    "selectOptionalItem": "Wybierz opcjonalną pozycję",
    "showActivity": "Pokaż działania"
  },
  "quoteStatus": {
    "ACCEPTED": "Zaakceptowany",
    "DRAFT": "Projekt",
    "NEGOTIATION": "W trakcie realizacji",
    "REJECTED": "Odrzucony",
    "REQUESTED": "Zapyzanie wyslane"
  },
  "readOnlyMode": "Obecnie jesteś w trybie tylko do odczytu.",
  "realtimePrices": "Ceny Realtime",
  "realtimePricesLoaded": "Ceny ładowane w czasie rzeczywistym",
  "recipients": "Odbiorcy",
  "refresh": "Odśwież",
  "refreshPage": "Przeładuj stronę",
  "register": "Zarejestruj się",
  "registerCompany": "Zarejestruj firmę",
  "registration": "Rejestracja",
  "registrationDisabled": "Rejestracja wyłączona",
  "registrationDisabledDescription": "Operator wyłączył rejestrację i logowanie do tego portalu.",
  "registrationLinkSent": "Na Twój adres e-mail została wysłana wiadomość z linkiem rejestracyjnym. Otwórz link, aby dokończyć rejestrację.",
  "registrationRequested": "Wniosek został przekazany do operatora portalu. Otrzymasz powiadomienie, gdy wniosek zostanie zaakceptowany.",
  "removeDialog": "Czy na pewno chcesz usunąć tego pracownika?",
  "removeProductFromCart": "Usuń produkt z koszyka",
  "removeProductFromCollection": "Usuń produkt z kolekcji",
  "removeProductFromQuoteRequest": "Usuń produkt z żądania",
  "requestPrice": "Zapytaj o cenę",
  "requestRegistration": "Wniosek o dostęp",
  "resetPassword": "Resetowanie hasła",
  "rma": {
    "requested": "Wysłano zapytanie zwrotne",
    "return": "Przesyłka zwrotna",
    "returned": "zwrócony",
    "returnReason": "Powód zwrotu",
    "selectedPositions": "Wybrane pozycje",
    "selectPositions": "Wybierz przedmioty do wysyłki zwrotnej",
    "selectProductForReturn": "Wybierz produkt do zwrotu",
    "selectReturnReason": "Wybierz przyczynę"
  },
  "save": "Zapisz",
  "saveAddress": " Przejmij adres",
  "search": "Szukaj",
  "searchAll": "Przeszukaj wszystkie",
  "searchResults": "Szukaj \"{0}\" w produktach",
  "send": "Wyślij",
  "sendInvitation": "Wyślij zaproszenie",
  "serialNumbers": {
    "copyAll": "skopiuj wszystko",
    "serialNumbers": "Numery seryjne",
    "serialNumbersCopied": "Numery seryjne skopiowane do schowka"
  },
  "serverOffline": {
    "description": "Portal jest obecnie niedostępny z powodu prac serwisowych. Spróbuj ponownie później.",
    "title": "Portal niedostępny"
  },
  "shippingCostsShort": "Wysyłka",
  "shoppingCart": "Koszyk",
  "shortUrl": {
    "enterZipCode": "Aby otworzyć ofertę, wprowadź kod pocztowy swojego adresu:",
    "enterZipCodeTitle": "Wprowadź kod pocztowy",
    "error": "Ups! Ten link jest nieprawidłowy!",
    "wrongZipCode": "Wprowadzony kod pocztowy jest nieprawidłowy!"
  },
  "showCategories": "Pokaż kategorie",
  "showErrorOrders": "Pokaż wszystkie zamówienia z błędem",
  "showPassword": "Pokaż hasło",
  "signIn": "Login",
  "signOut": "Logout",
  "sortBy": "Sortuj według",
  "sortbyAsc": "Sortuj w porządku rosnącym według „{0}”",
  "sortByDesc": "Sortuj malejąco według „{0}”",
  "sources": "Źródła zaopatrzenia",
  "status": "Status",
  "stock": "Zapasy",
  "stockStatus": {
    "Available": "Dostępne",
    "NotAvailable": "Niedostępne",
    "OnOrder": "Na podstawie zamówienia",
    "OnStock": "W magazynie",
    "Ordered": "Wkrótce dostępne",
    "Unknown": "Nieznany",
    "Warehouse": "W magazynie zewnętrznym"
  },
  "stockStatusDescription": "Stan zapasów to „{0}”",
  "subsidiaryMode": "Widok klienta - Jesteś zalogowany w {0}",
  "success": {
    "addedToCollection": "Produkt został dodany do kolekcji",
    "addedToCollectionLink": "Produkt został dodany do kolekcji \"{0}\" >>",
    "addedToComparison": "Produkt dodany do porównania",
    "addedToQuote": "Produkt został pomyślnie dodany do zapytania",
    "addedToQuoteLink": "Produkt został pomyślnie dodany do zapytania \"{0}\". >>",
    "addressCreated": "Adres został utworzony",
    "addressDeleted": "Adres został usunięty",
    "addressSaved": "Adres został zapisany",
    "cartRefreshed": "Koszyk zakupów został zaktualizowany",
    "changeLanguage": "Język zmieniony",
    "changePassword": "Hasło zostało zmienione",
    "essentialShopActivationRequested": "Zapytanie o aktywację zostało wysłane",
    "invitationSent": "Zaproszenie zostało wysłane",
    "orderArchived": "Zamówienie zarchiwizowane",
    "orderDearchived": " Zamówienie odarchiwizowane ",
    "productAdded": "Produkt został dodany do koszyka",
    "productDeleted": "Produkt został usunięty z koszyka",
    "productRequested": "Zapytanie do produktu zostało wysłane",
    "quoteArchived": "Oferta zarchiwizowana",
    "quoteDearchived": "Oferta odarchiwizowana",
    "registrationComplete": "Rejestracja zakończona",
    "removedFromComparison": "Produkt został usunięty z porównania",
    "resetPassword": "Wiadomość e-mail została wysłana na adres \"{0}\", jeśli istnieje aktywne konto użytkownika."
  },
  "supplier": "Dostawca",
  "supplierPid": " Dystrybutor nr.",
  "switchSubsidiary": "Zmień fimę ",
  "switchSubsidiaryHint": "Możesz zalogować się do innych firm",
  "technicalData": "Dane techniczne",
  "terms": " Regulamin",
  "time": {
    "day": "dzień",
    "hour": "godzina",
    "minute": "minuta",
    "month": "miesiąc",
    "year": "rok"
  },
  "title": "Tytuł",
  "to": "do",
  "today": "Dzisiaj",
  "topiExpiredHint": "Oferta w topi niestety wygasła. Prosimy o ponowne dodanie produktów do koszyka za pomocą menu z trzema kropkami, a następnie kliknięcie „Continue to rental configuration”.",
  "transactionType": {
    "DELIVERY": "List przewozowy",
    "INVOICE": "Faktura proforma",
    "ORDER": "Zamówienie",
    "ORDERSTATUS": "Potwierdzenie zamówienia",
    "PAYMENT": "Płatność"
  },
  "unknown": "nieznany",
  "updated": " Zaktualizowano",
  "user": {
    "avatar": "Avatar",
    "company": "Firma",
    "contactTitle": "Tytuł kontaktu",
    "department": "Dział",
    "email": "E-mail",
    "firstName": "Imię",
    "language": "Język",
    "lastName": "Nazwisko",
    "permissions": {
      "changeSubsidiary": "Zmień firmę",
      "changeSubsidiaryDescription": "Określa, czy użytkownik ma prawo logować się do firm powiązanych.",
      "permissions": "Uprawnienia użytkowników",
      "shopAdmin": "Administrator",
      "shopAdminDescription": "Jako administrator, użytkownik ma prawo do edycji uprawnień, danych kontaktowych, limitów zamówień i zatwierdzania zamowień innych pracowników. Dodatkowo użytkownik admin może zapraszać nowych współpracowników bezpośrednio do portalu.",
      "submitOrder": "Składanie zamówień",
      "submitOrderDescription": "Określ, czy użytkownik ma prawo do składania zamówień."
    },
    "phone": "Numer telefonu",
    "phoneMobile": "Numer telefonu komórkowego",
    "settings": {
      "allowTracking": "Poprawa komfortu użytkowania",
      "allowTrackingDescription": "Weź udział w programie optymalizacji, aby poprawić komfort użytkowania.",
      "settings": "Ustawienia użytkownika"
    }
  },
  "validDate": "Ważny do",
  "viewToggle": {
    "ordersApprovals": "Przełącz przegląd zamówienia na „Zamówienia do zatwierdzenia”",
    "ordersGrid": "Przełącz przegląd zamówienia na widok kolumny",
    "ordersList": "Przełącz przegląd zamówienia, aby wyświetlić widok na listę",
    "productsCards": "Przełącz przegląd produktu na widok kafelkowy",
    "productsList": "Przełącz przegląd produktu, aby wyświetlić widok na listę",
    "quoteActivityChat": "Przełącz widok aktywności na czat",
    "quoteActivityHistory": "Przełączanie działań na historię"
  },
  "windowTitle": {
    "Collection": "Kolekcja",
    "CompanyOrderLimit": "Zatwierdzenie zamówienia",
    "Login": "Strona logowania",
    "Registration": "Strona rejestracyjna",
    "StartPage": "Strona startowa"
  },
  "writeSomething": "Napisz coś...",
  "yes": "Tak",
  "yesterday": "Wczoraj"
}
